<div>
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>

        <div class="page_main_sec">
            <div class="row selection-sec">
                <div class="row">
                    <div class="col-lg-3 text-center">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="request_type">Request Type <span
                                    class="field-mandatory">*</span></mat-label>
                            <mat-select [(ngModel)]="selectedRequestType"
                                (selectionChange)="onSelectRequestType($event.value)"
                                (click)="searchText_RequestType.focus()" (focus)="searchText_RequestType.focus()"
                                (closed)="searchText_RequestType.value=''" id="request_type">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText_RequestType
                                    autocomplete="off" class="mat-select-search" placeholder="Select Request">
                                <mat-option [value]="option"
                                    *ngFor="let option of lstRequestType| listFilter:{'name':searchText_RequestType.value}">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3 text-center">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="user_selection">Select User <span
                                    class="field-mandatory">*</span></mat-label>
                            <mat-select [(ngModel)]="selectedUser" (selectionChange)="onUserChange($event.value)"
                                (click)="searchText_user.focus()" (focus)="searchText_user.focus()"
                                (closed)="searchText_user.value=''" id="user_selection">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText_user
                                    autocomplete="off" class="mat-select-search" placeholder="Select User">
                                <mat-option [value]="option"
                                    *ngFor="let option of lstUser| listFilter:{'name':searchText_user.value}">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3 text-center">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="role_selection">Role Selection <span
                                    class="field-mandatory">*</span></mat-label>
                            <mat-select [(ngModel)]="selectedRole" (selectionChange)="onRoleChange($event.value)"
                                (click)="searchText_role.focus()" (focus)="searchText_role.focus()"
                                (closed)="searchText_role.value=''" id="role_selection">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText_role
                                    autocomplete="off" class="mat-select-search" placeholder="Select Role">
                                <mat-option [value]="option"
                                    *ngFor="let option of lstRole| listFilter:{'name':searchText_role.value}">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 text-center">
                        <mat-form-field [style.width.%]="100">
                            <mat-label for="from_date">From Date<span class="field-mandatory">*</span></mat-label>
                            <input matInput readonly [(ngModel)]="fromDate" [min]="minFromDate"
                                [matDatepicker]="picker1" name="fromDate" [placeholder]="'From Date'" id="from_date">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-lg-3 text-center">
                        <mat-form-field [style.width.%]="100">
                            <mat-label for="to_date">To Date<span class="field-mandatory">*</span></mat-label>
                            <input matInput readonly [(ngModel)]="toDate" [min]="minToDate" [matDatepicker]="picker2"
                                name="toDate" [placeholder]="'To Date'" id="to_date">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div class="col-lg-3 text-center">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="proxy_user">Select Proxy User <span
                                    class="field-mandatory">*</span></mat-label>
                            <mat-select [(ngModel)]="selectedProxyUser"
                                (selectionChange)="onProxyUserChange($event.value)"
                                (click)="searchText_proxyuser.focus()" (focus)="searchText_proxyuser.focus()"
                                (closed)="searchText_proxyuser.value=''" id="proxy_user">
                                <input type="search" (keydown)="$event.stopPropagation()" #searchText_proxyuser
                                    autocomplete="off" class="mat-select-search" placeholder="Select Proxy User">
                                <mat-option [value]="option"
                                    *ngFor="let option of lstProxyUser| listFilter:{'name':searchText_proxyuser.value}">
                                    {{option.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div *ngIf="isshowstatus" class="col-lg-3 text-center">
                        <mat-form-field appearance="legacy" [style.width.%]="100">
                            <mat-label for="status">Status <span class="field-mandatory">*</span></mat-label>
                            <mat-select [(ngModel)]="selectedStatus" (selectionChange)="onStatusChange($event.value)"
                                id="status">
                                <mat-option [value]="status" *ngFor="let status of lstStatus">
                                    {{status.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 text-end">
                        <button class="btncss me-2 btn_primary" [class.btn_disable]="isSubmitEnable"
                            [class.btn_primary]="!isSubmitEnable" [disabled]="isSubmitEnable"
                            (click)="onSubmitButtonClick()">Submit</button>
                        <button type="button" class="btncss me-2 btn_secondary" (click)="onResetButtonClick()">
                            Reset
                        </button>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div>                   
                    <input type="button" value="Show History" class="btncss me-2 btn_primary" (click)="onHistoryShowButtonClick()">
                </div>
            </div> -->
            <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="start">
                <mat-tab label="Active">
                    <div *ngIf="isShowHistory && lstHistory.length>0" class="row selection-sec selectionSearch">
                        <app-basic-gridview [lstData]="lstHistory" [gridTitle]=""
                            [columnsToHide]="proxyHistoryColumnsToHide" [showExcelDownloadOption]="false"
                            [showSearchOption]="true" [showRecordsPerPageOption]="true" [hyperlinkCols]="['delete']"
                            [showPagination]="true" (cellClickEvent)="cellClickEvent($event)"></app-basic-gridview>
                    </div>
                </mat-tab>
                <mat-tab label="History">
                    <div *ngIf="isshowProxyTrail && lstProxyTrail.length>0" class="row selection-sec selectionSearch">
                        <app-basic-gridview [lstData]="lstProxyTrail" [gridTitle]=""
                            [columnsToHide]="proxyHistoryColumnsToHide" [showExcelDownloadOption]="false"
                            [showSearchOption]="true" [showRecordsPerPageOption]="true" [hyperlinkCols]="['delete']"
                            [showPagination]="true" (cellClickEvent)="cellClickEvent($event)"></app-basic-gridview>
                    </div>
                </mat-tab>

            </mat-tab-group>



        </div>
    </div>
</div>